<template>
<div class="content">
  <controlbar :dispItems='dispBeacons' @input-event="beaconFindAction">
  </controlbar>
  <div class="center">
    <table class="content_title" rules='rows'>
      <tr class="items_table">
        <th class='table_checkbox'>
          <input type="checkbox" class="checkbox" :checked="checked" @click="allCheckedAction">
        </th>
        <td class='table_contents'>
          <label class="beacon_id_label">
            {{locationIdLabel}}
          </label>
        </td>
        <td class='table_contents'>
          <label class="location_name_label">
            {{locationNameLabel}}
          </label>
        </td>
      </tr>
    </table>
    <div class='table_scroll' :style="{height: tableHeight}">
      <table class="items_table" rules='rows'>
        <tr class='item_table_row' v-for="dispBeacon in dispBeacons" :key="dispBeacon.locationId">
          <th class='table_checkbox'>
            <input type="checkbox" class="checkbox" v-model="dispBeacon.checked">
          </th>
          <td class='table_contents' @click=setActive(dispBeacon)>
            <label class="location_id">
              {{dispBeacon.locationId}}
            </label>
          </td>
          <td class='table_contents' @click=setActive(dispBeacon)>
            <label class="location_name">
              {{dispBeacon.locationName}}
            </label>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="bottom">
    <pagenation :dispItems='beacons' @child-event="createBeaconsList">
    </pagenation>
  </div>
  <div class="false_modal_window" v-if='showFalseModal'>
    <falseModalWindow :question='falseWord' @close="close">
    </falseModalWindow>
  </div>
  <div class="loading_modal_window" v-if='showloadingModal'>
    <loadingModalWindow @close="close">
    </loadingModalWindow>
  </div>
</div>
</template>

<script>
import controlbar from './controlbar.vue'
import pagenation from '../pagenation.vue'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data () {
    return {
      locationIdLabel: 'ビーコンID',
      locationNameLabel: '場所名',
      dispBeacons: [],
      findBeacons: [],
      windowHeight: '',
      showFalseModal: false,
      falseWord: '',
      checked: false,
      inputValue: '',
      showloadingModal: false
    }
  },
  computed: {
    beacons () {
      if (this.inputValue === '') {
        return this.$store.state.beacons.beacons
      }
      return this.findBeacons
    },
    errorMsg () {
      return this.$store.state.error.errorMsg
    },
    tableHeight () {
      const otherHeight = 138
      return (this.windowHeight - otherHeight) + 'px'
    }
  },
  async created () {
    this.showloadingModal = true
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    try {
      await this.$store.dispatch('beacons/setBeacons')
    } catch (error) {
      let eventNumber = this.$store.state.error.errorCode.errorCode_390001
      let eventType = 3
      let reason = 'MSGCRC0080 '
      if (error.response) {
        this.falseWord = this.errorMsg.MSGCRC0080.name + this.errorMsg.MSGCRC0080.value + 'エラーコード：{' + eventNumber + '}'
        reason += error.response.status
      } else {
        reason = 'MSGCRC0005'
        eventType = 9
        this.falseWord = this.errorMsg.MSGCRC0005.name + this.errorMsg.MSGCRC0005.value + 'エラーコード：{' + eventNumber + '}'
      }
      try {
        this.$store.dispatch('masters/writeLog', {eventNumber, eventType, reason})
      } catch (error) {
      }
      this.showFalseModal = true
    }
    this.showloadingModal = false
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    pagenation,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize () {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight () {
      this.windowHeight = window.innerHeight
    },
    allCheckedAction (e) {
      // リストのチェックボックスを全てチェックする。
      this.checked = !this.checked
      for (let i = 0; i < this.dispBeacons.length; i++) {
        this.dispBeacons[i].checked = this.checked
      }
    },
    close (e) {
      this.showFalseModal = false
    },
    createBeaconsList (e) {
      // 表示するリストをページネーションから受け取る。
      this.dispBeacons = e
      this.checked = false
    },
    beaconFindAction (e) {
      this.inputValue = e
      this.findBeacons = this.$store.getters['beacons/getBeaconById'](e)
    },
    async setActive (payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch('beacons/setDetailBeacon', payload)
        this.$router.push('../beacons/detail')
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_390002
        let eventType = 3
        let reason = 'MSGCRC0081 '
        if (error.response) {
          this.falseWord = this.errorMsg.MSGCRC0081.name + this.errorMsg.MSGCRC0081.value + 'エラーコード：{' + eventNumber + '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord = this.errorMsg.MSGCRC0005.name + this.errorMsg.MSGCRC0005.value + 'エラーコード：{' + eventNumber + '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {eventNumber, eventType, reason})
        } catch (error) {
        }
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/beacons/beaconsList.vue